export default __webpack_public_path__ + "static/media/downarrow_80895.b47027cb.svg";